import { Divider } from 'antd';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { ConnectorCard } from '@component/connector-card/connector-card';
import { SkeletonCards } from '@component/skeleton/skeleton-cards/skeleton-cards';
import { TestIdsEnum } from '@enum/test-ids.enum';
import { getTestId } from '@util/data/get-test-id';

import { useApplicationSetupConnectorsPage } from './application-setup-connectors.hook';
import { BodyWrapper, Description, Footer, Title, Wrapper } from './application-setup-connectors.style';

export const ApplicationSetupConnectorsPage = () => {
  const { data, isLoading, onNext } = useApplicationSetupConnectorsPage();

  return (
    <Wrapper>
      <Title level={2} weight={400}>
        Enable integrations
      </Title>
      <Description>
        Please select the integrations you want to activate. You can revisit and change these settings at any time.
      </Description>
      <Divider />
      <BodyWrapper gutter={[16, 16]} id='step-3'>
        {isLoading && <SkeletonCards />}
        {!isLoading &&
          data.map((connector) => <ConnectorCard key={connector.id} connector={connector} shouldConfigure={false} />)}
      </BodyWrapper>
      <Footer>
        <div id='step-4'>
          <Button type={ButtonTypeEnum.Primary} block onClick={onNext} {...getTestId(TestIdsEnum.CommonButtonContinue)}>
            CONTINUE
          </Button>
        </div>
      </Footer>
    </Wrapper>
  );
};
